import { ReactNode } from "react";
import {
  AdvancedMarker,
  InfoWindow,
  useAdvancedMarkerRef,
} from "@vis.gl/react-google-maps";
import PinIcon from "../../../../assets/icons/start_point.png";

type LocationPinMarkerProps = {
  position: google.maps.LatLngLiteral;
  showInfoWindow: () => void;
  closeInfoWindow: () => void;
  isActive?: boolean;
  children?: ReactNode;
};

export const LocationPinMarker = ({
  position,
  showInfoWindow,
  closeInfoWindow,
  isActive,
  children,
}: LocationPinMarkerProps) => {
  const [markerRef, marker] = useAdvancedMarkerRef();

  return (
    <>
      <AdvancedMarker
        ref={markerRef}
        position={position}
        onClick={showInfoWindow}
      >
        <img src={PinIcon} alt="pin" />
      </AdvancedMarker>
      {isActive && children && (
        <InfoWindow
          anchor={marker}
          position={position}
          onClose={closeInfoWindow}
        >
          {children}
        </InfoWindow>
      )}
    </>
  );
};
